import Cookies from 'js-cookie';

function MainController($timeout, $q, $route, $window, CharitySvc, SiteWinnersSvc, $sce, $scope, $translate, $rootScope, SponsorSvc, SiteDetailsSvc, PlansSvc, SiteDetail_AddressSvc, $http, $location, EmailRegistrationgSvc, EmailLoginSvc, EmailForgotSvc, BuyLinkSvc, NextDrawSvc, CartSvc, PurchaseByCreditSvc, SetInitialEmailSvc, PayPalPurchaseSvc, NewsLetterSvc, ResetPasswordSvc, ResendEmailSvc, InteracPurchaseSvc, EmailFinalizationSvc, ClonefrominviteSvc, TicketHandlerSvc, MyTicketsMonthYearSvc, AffiliateSvc) {
  "ngInject";
  $scope.SandboxClosed = true;
  $scope.ShowButton = false;

  $scope.Close_Sandbox = function () {
    $scope.SandboxClosed = true;
    jQuery(document).ready(function ($) {

      var SandboxClosed = Cookies.get('SandboxClosed');
      var date = new Date();
      var minutes = 1440;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.get('SandboxClosed', 'true', { expires: date });
    });
  }

  $scope.Sponsor = {};
  $scope.CopyRightYear = new Date().getFullYear();
     
  $(function () {
    setTimeout(function() {
      var signalr_connection = $.connection.lottoFactoryHub;
      signalr_connection.connection.url = signalr_url;
      signalr_connection.client.userPurchase = function (message) {
          $scope.$broadcast('broadcast.userPurchase', { message: JSON.parse(message) });
      };
      signalr_connection.client.drawStatus = function (message) {
        //console.log("In Hub Call Draw Status - " + message);
        $scope.$broadcast('broadcast.drawStatus', { message: message });
      };
      $.connection.hub.start({jsonp:true, transport: ['webSockets'] }).done(function () {
        signalr_connection.server.subscribe(TFL_ID);
      });
      $.connection.hub.disconnected(function() {
        setTimeout(function() {
          $.connection.hub.start({jsonp:true}).done(function () {
          });
        }, 5000); // Re-start connection after 5 seconds
      });
    },2000);
  });

  function hide_step(step) {
    var elements = document.getElementsByClassName('drawing-step' + step);
    for(var i = 0; i < elements.length; i++){
      elements[i].classList.add('hide-step');
    }
  }

  function show_step(step) {
      var elements = document.getElementsByClassName('drawing-step' + step);
      for(var i = 0; i < elements.length; i++){
        elements[i].classList.remove('hide-step');
      }
  }

  var draw_started = false;
  var still_started = false;
  $scope.$on('broadcast.drawStatus', function (event, args) {

    //console.log("broadcast.drawStatus Function - " + args.message);

    if (document.location.pathname != '/') {
      document.location = '/';
    }
    if (args.message == 'Started')
    {
      still_started = true;
      $rootScope.CanPurchase = false;
      $scope.$apply();
      $timeout(function() { //Give the UI a chance to load
        hide_step(2);
        hide_step(3);
        hide_step(4);
        document.getElementsByClassName('main-cover')[0].classList.add('expand-main');
        show_step(1); // Drawing Started
        $timeout(function() {
           if (still_started)
           {
            $scope.$broadcast('broadcast.drawStatus', { message: 'Drawn' });
           } 
        }, 300000); //5 Mins
      },2000);
    }
    if (args.message == 'Drawn')
    {
      document.getElementById('show-jackpots').style.display = 'none';
      draw_started = true;
      still_started = false;
      hide_step(2);
      hide_step(3);
      hide_step(4);
      document.getElementsByClassName('main-cover')[0].classList.add('expand-main');
      show_step(1); // Drawing Started
      SiteWinnersSvc.list({}, function (data) {
        $rootScope.CurrentWinner = data[0];
        setTimeout(function() {
          hide_step(1); // Drawing Started
          show_step(2);
          setTimeout(function() {
            show_step(3);
              setTimeout(function() {
                show_step(4); 
                document.getElementsByClassName('pyro')[0].style.display = 'block';
                setTimeout(function() {
                  draw_started = false;  
                  $scope.$broadcast('broadcast.UpdateDraw', { message: 'Drawn' });
                  document.getElementsByClassName('pyro')[0].style.display = 'none';
                  document.getElementsByClassName('main-cover')[0].classList.remove('expand-main');
                  hide_step(1);
                  hide_step(2);
                  hide_step(3);
                  hide_step(4); 
                  PlansSvc.get({ OrganizationId: TFL_ID }, function (data) {
                    $scope.Plans = data;
                  });
                  $rootScope.SiteDetails.DrawsRemaining = 1;
                  $rootScope.WinnersList = data;
                  document.getElementById('show-jackpots').style.display = '';
                },8000);
              },3000);
            },3000);
          },3000);
      });

    }
    if (args.message == 'Finished')
    {
      
        if (draw_started == false)
        {
          $scope.$broadcast('broadcast.UpdateDraw', { message: 'Drawn' });
          setTimeout(function() {
            document.getElementsByClassName('main-cover')[0].classList.remove('expand-main');
            hide_step(1);
            hide_step(2);
            hide_step(3);
            hide_step(4); 
        
          }, 3000);
        }
    }
    
  });


  var sponsorPromise = new Promise(function (resolve, reject) {
    SponsorSvc.get({}, function (data) {
      $scope.Sponsor = data;
      resolve(true)
    });
  });

  $scope.youtubeLoader = function (url) {
    return "https://www.youtube.com/embed/" + url;
  }

  jQuery(document).ready(function ($) {
    if (Cookies.get('SandboxClosed') !== undefined && Cookies.get('SandboxClosed') != '') {
      $scope.SandboxClosed = true;
    }
    else {
      $scope.SandboxClosed = false;
    }
  });

  $scope.ErrorShake = false;

  $scope.TFL_Client_Location = TFL_Client_Location;
  $scope.IPAddress = IPAddress;

  jQuery(document).ready(function ($) {
    if (Cookies.get('TLF_LastPage') !== undefined && Cookies.get('TLF_LastPage') != '') {
      var lastpage = Cookies.get('TLF_LastPage');
      var date = new Date();
      var minutes = 60000;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.set('TLF_LastPage', '', { expires: date });
      $location.url($location.path(lastpage).replace());
      $location.path(lastpage).replace();
      $route.reload();
    }
  });

//Check for Charity passed in or stored in cookie
  if (CharityEnabled == true || Cookies.get('CharityID') != null) 
  {
    //Remove affiliate if exisits
    if (Cookies.get('AffiliateID') != null) {
      Cookies.remove('AffiliateID');
      $rootScope.Affiliate = null;
    }

    if (Cookies.get('CharityID') == null)
    {
      var date = new Date();
      var minutes = 60000;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.set('CharityID', CharityID, { expires: date });
    }
    else if (CharityEnabled == true)
    {
      var date = new Date();
      var minutes = 60000;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.set('CharityID', CharityID, { expires: date });
    }

    CharitySvc.get({ Id:  Cookies.get('CharityID')}, function (data) {
      if (data.Id != null)
      {
        if (Cookies.get('TLF_Auth_Token') != null) {
          CharitySvc.member_set({ APIKey: Cookies.get('TLF_Auth_Token'), Id:  Cookies.get('CharityID')}, function (data) { });
        }
        $rootScope.Charity_Enabled = true;
        $rootScope.Charity = data;

        gtag('event', 'charity_selected', {
          'event_category': 'Charity',
          'value': $rootScope.Charity.Name
        });

      }
    });
  }
  else
  {
    gtag('event', 'charity_selected', {
      'event_category': 'Charity',
      'value': 'None Selected'
    });
  }




  //Check for Affiliate passed in or stored in cookie
  if (AffiliateEnabled == true || Cookies.get('AffiliateID') != null) 
  {
    //Remove charity if exisits
    if (Cookies.get('CharityID') != null) {
      Cookies.remove('CharityID');
      $rootScope.Charity = null;
    }

    if (Cookies.get('AffiliateID') == null)
    {
      var date = new Date();
      var minutes = 60000;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.set('AffiliateID', AffiliateID, { expires: date });
    }
    else if (AffiliateEnabled == true)
    {
      var date = new Date();
      var minutes = 60000;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.set('AffiliateID', AffiliateID, { expires: date });
    }

    AffiliateSvc.get({ Id:  Cookies.get('AffiliateID')}, function (data) {
      if (data.Id != null)
      {
        if (Cookies.get('TLF_Auth_Token') != null) {
          AffiliateSvc.member_set({ APIKey: Cookies.get('TLF_Auth_Token'), Id: Cookies.get('AffiliateID') }, function (data) { });
        }
        $rootScope.Affiliate_Enabled = true;
        $rootScope.Affiliate = data;

        gtag('event', 'affiliate_selected', {
          'event_category': 'Affiliate',
          'value': $rootScope.Affiliate.Name
        });
      }
    });
  }
  else
  {
    gtag('event', 'affiliate_selected', {
      'event_category': 'Affiliate',
      'value': 'None Selected'
    });
  }

  $scope.Hide_Signup = function () {
    jQuery(document).ready(function ($) {
      $('#sign-up').hide();
    });
  }
  $scope.Hide_AgeGate = function () {
    jQuery(document).ready(function ($) {
      $('#age-gate').hide();
    });
  }

  $scope.OrderHistory = []
  $scope.fetchOrderHistory = function () {
    $http.get(TFL_Base_Url + 'admin/reports/orderHistory?ApiKey=' + Cookies.get('TLF_Auth_Token'))
      .then(function (response) {
        $scope.OrderHistory = response.data
      });
  }

  $scope.ActiveSlides = []
  $scope.ActiveBodySlides = []
  $scope.ActiveBannerSlides = []

  $scope.buildHomeSlides = function (Page) {
    $scope.ActiveSlides = []
    $translate(Page).then(function (result) {
      result.split(";").forEach(function (slide, index) {
        if (index < result.split(";").length) {
          $scope.ActiveSlides.push(JSON.parse(slide));
        }
      });
    });
  }

  $scope.buildSlidesBody = function (slidesUrl) {
    $translate(slidesUrl).then(function (result) {
      $scope.ActiveBodySlides = result.split(',');
    });
  }

  $scope.buildSlidesBanner = function (slidesUrl) {
    $translate(slidesUrl).then(function (result) {
      $scope.ActiveBannerSlides = result.split(',');
    });
  }

  $scope.GACode = '';
  $translate('FooterAnalyticsID').then(function (result) {
    $scope.GACode = result;
  });


  $scope.GetGAID = function () {
    return $scope.GACode;
  }

	$scope.ActiveSlides = []
	$scope.ActiveBodySlides = []
    $scope.ActiveBannerSlides = []

  $scope.buildHomeSlides = function (Page) {
    $scope.ActiveSlides = []

    sponsorPromise.then(function (value) {
      $translate($scope.Sponsor.SlidesId).then(result => {
        if (result != " ") {
          result.split(";").forEach(function (slide, index) {
            if (index < result.split(";").length) {
              $scope.ActiveSlides.push(JSON.parse(slide));
            }
          });
        }
      }, reason => {
      });
      $translate(Page).then(function (result) {
        result.split(";").forEach(function (slide, index) {
          if (index < result.split(";").length) {
            $scope.ActiveSlides.push(JSON.parse(slide));
          }
        });
      });
    });
  }

	$scope.buildSlidesBody = function (slidesUrl) {
		$translate(slidesUrl).then(function (result) {
			$scope.ActiveBodySlides = result.split(',');
		});
	}

	$scope.buildSlidesBanner = function (slidesUrl) {
		$translate(slidesUrl).then(function (result) {
			$scope.ActiveBannerSlides = result.split(',');
		});
	}

	$scope.GACode = '';
	$translate('FooterAnalyticsID').then(function (result) {
		$scope.GACode =  result;
	});


	$scope.GetGAID = function ()
	{
		return $scope.GACode;
	}

	$rootScope.$on('$translateChangeSuccess', function (event, args) {
		$rootScope.TranslationTableLoaded = true;
	});

  $rootScope.TFL_Core_Template_Location = TFL_Core_Template_Location;
  $rootScope.OrgID = TFL_ID;


  jQuery(document).ready(function ($) {
    if (Cookies.get('Finalize_Member') != undefined && Cookies.get('Finalize_Member') != '') {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {

        ClonefrominviteSvc.get({ CurrentApiKey: Cookies.get('TLF_Auth_Token'), InvitedMemberId: Cookies.get('Finalize_Member') }, function (data) {

          var date = new Date();
          var minutes = 60000;
          date.setTime(date.getTime());
          Cookies.set('Finalize_Member', '', { expires: date });

          $timeout(function () {
            $('#modal').show();
            $('#invite_complete').fadeIn(500);
          });

        });

      }
    }
  });

  $scope.LaunchEmailReg = function () {
    jQuery(document).ready(function ($) {
      $('#modal').fadeIn(500, function () {
        $('#sign-up').hide();
        $('#sign-up-form').show();
      });
    });
  }

  $scope.LaunchFacebookReg = function () {
    jQuery(document).ready(function ($) {
      $('#modal').fadeIn(500, function () {
        $('#sign-up').hide();
        $('#postal-code').show();
      });
    });
  }

  $scope.RegWithEmail = function () {
    $timeout(function () {
      $scope.ShowPostalCode = false;
    });
    jQuery(document).ready(function ($) {
      $('#modal').fadeIn(500, function () {
        $('#sign-up').hide();
        $('#sign-up-form').show();
      });
    });
  }



  $scope.SignUpWithFacebook = function () {
    jQuery(document).ready(function ($) {
      $scope.PostalError = true;
      $scope.EmailCheckValidationPassed = false;
      $.ajax({
        url: '//geocoder.ca/?postal=' + $scope.PostalCode + '&geoit=xml&json=1&standard=1&showcountry=1&moreinfo=1&showaddrs=1&standard=1&auth=300748397340449240769x3775',
        type: "GET",
        async: true,
        crossDomain: true,
        success: function (data) {
          if (data.error != undefined) {
            $scope.PostalError = true;
            $scope.EmailCheckValidationPassed = false;
          }
          else {
            if (data.streets.street == undefined) {
              $scope.PostalError = true;
              $scope.EmailCheckValidationPassed = false;
            } else {
              if (data.streets.street.length > 0) {

                $scope.PostalError = false;
                document.location = $rootScope.SiteDetails.FacebookLoginUrl;
              }
              else {
                $scope.PostalError = true;
                $scope.EmailCheckValidationPassed = false;
              }
            }
          }
        }
      });
    });
  }


  $scope.MemberValue = Cookies.get('TLF_Auth_Token')
  if (Cookies.get('TLF_Auth_Token') == undefined)
    $scope.MemberValue = ""
    PlansSvc.get({ ApiKey: $scope.MemberValue, OrganizationId: TFL_ID }, function (data) {

    $scope.Plans = data;
  });


  $rootScope.CloseSideNav = function () {
    jQuery(document).ready(function ($) {
      $('.nav-trigger').removeClass('active');
      $('header .nav').animate({
        'margin-left': -310
      }, 300);
      $('.click-cover').hide();
    });
  }


  $rootScope.CloseConfirmModal = function () {
    jQuery(document).ready(function ($) {
      $('#modal').hide();
      //You have mail
      $('#complete').fadeOut(400);
      //Thank you stop light
      $('#password-reset-2').fadeOut(400);
      //locked-out
      $('#locked-out').fadeOut(400);
      //email confirm
      $('#email-confirmed').fadeOut(400);
    });
  }

  $scope.SendConfirmAgain = function () {
    jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
        ResendEmailSvc.get({ APIKey: Cookies.get('TLF_Auth_Token') }, function (data) {
          $rootScope.CloseConfirmModal();
        });
      }
    });
  }

  $scope.interac_post = '';

  $scope.PurchaseInterac = function () {
    jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
        InteracPurchaseSvc.get({ APIKey: Cookies.get('TLF_Auth_Token') }, function (data) {
          var interact_text = unescape(data.contents).replace(/\+/g, " ");
          $scope.interac_post = interact_text;
        });
      }
    });
  }

  //Join Email
  $scope.JoinEmail = '';
  $scope.JoinText = 'Invalid email';
  $scope.JoinEmailError = false;
  $scope.CheckJoinEmail = function () {
    $scope.JoinText = 'Invalid Email';
    if ($scope.JoinEmail == '') {
      $scope.JoinEmailError = true;
    }
    else {

      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test($scope.JoinEmail)) {
        $scope.JoinEmailError = false;
        //NewsLetterSvc
        NewsLetterSvc.post({}, { Email: $scope.JoinEmail }, function (data) {

          $scope.JoinEmail = '';
          $scope.JoinText = 'Thank you for signing up';
          $scope.JoinEmailError = true;

        });
      }
      else {
        $scope.JoinEmailError = true;
      }
    }
  }

  //Cart Count
  $rootScope.CartItems_Count = 0;
  $rootScope.CartItems_Total = 0;
  jQuery(document).ready(function ($) {
    if (Cookies.get('TLF_Auth_Token') !== undefined) {
      CartSvc.get({ APIKey: Cookies.get('TLF_Auth_Token') }, function (data) {
        $rootScope.CartItems_Count = data.length;
      });
    }
  });

  $scope.ShowPostalCode = true;
  $scope.EmailCheckValidationPassed = false;
  $scope.FirstName = '';

  //Validation For Email SignUp
  $scope.FirstNameError = false;
  $scope.CheckFirstName = function () {
    if ($scope.FirstName == '') {
      $scope.FirstNameError = true;
      $scope.EmailCheckValidationPassed = false;
    }
    else {
      $scope.FirstNameError = false;
    }
  }
  
  $scope.LastName = '';
  $scope.LastNameError = false;
  $scope.CheckLastName = function () {
    if ($scope.LastName == '') {
      $scope.LastNameError = true;
      $scope.EmailCheckValidationPassed = false;
    }
    else {
      $scope.LastNameError = false;
    }
  }

  $scope.Email = '';
  $scope.EmailError = false;
  $scope.CheckEmail = function () {
    if ($scope.Email == '') {
      $scope.EmailError = true;
      $scope.EmailCheckValidationPassed = false;
    }
    else if ($scope.Email != $scope.Email1) {
      $scope.EmailsDontMatch = false;
      $scope.Email1Error = true;
      $scope.EmailCheckValidationPassed = false;
    }
    else if ($scope.Email == $scope.Email1) {
      $scope.EmailCheckValidationPassed = true;
      $scope.Email1Error = false;
      $scope.EmailsDontMatch = true;      
      $scope.EmailError = false;
    }
    else {
      $scope.EmailError = false;
    }
  }

  $scope.PostalCode = '';
  $scope.PostalError = false;
  $scope.CheckPostal = function () {
    $timeout(function () {
      if ($scope.PostalCode == '' || $scope.PostalCode.length < 6) {
        $scope.PostalError = true;
        $scope.EmailCheckValidationPassed = false;
      }
      else {
        jQuery(document).ready(function ($) {
          $.ajax({
            url: '//geocoder.ca/?postal=' + $scope.PostalCode + '&geoit=xml&json=1&standard=1&showcountry=1&moreinfo=1&showaddrs=1&standard=1&auth=300748397340449240769x3775',
            type: "GET",
            async: true,
            crossDomain: true,
            success: function (data) {
              if (data.error != undefined) {
                $scope.PostalError = true;
                $scope.EmailCheckValidationPassed = false;
              }
              else {
                if (data.streets.street == undefined) {
                  $scope.PostalError = true;
                  $scope.EmailCheckValidationPassed = false;
                } else {
                  if (data.streets.street.length > 0) {

                    $scope.PostalError = false;
                    if ($scope.CommitSignup == true) {
                      $scope.DoSignup();
                    }
                  }
                  else {
                    $scope.PostalError = true;
                    $scope.EmailCheckValidationPassed = false;
                  }
                }
              }
            }
          });
        });
      }
    });
  }

  $scope.Password = '';
  $scope.PasswordError = false;
  $scope.CheckPassword = function () {
    if ($scope.Password == '') {
      $scope.PasswordError = true;
      $scope.EmailCheckValidationPassed = false;
    }
    else {
      $scope.PasswordError = false;
    }
  }

  $scope.Password1 = '';
  $scope.Password1Error = false;
  $scope.PasswordsDontMatch = false;
  $scope.CheckPassword1 = function () {
    if ($scope.Password1 == '') {
      $scope.Password1Error = true;
      $scope.EmailCheckValidationPassed = false;
    }
    else {
      if ($scope.Password != $scope.Password1) {
        $scope.PasswordsDontMatch = false;
        $scope.Password1Error = true;
        $scope.EmailCheckValidationPassed = false;
      } else {
        $scope.Password1Error = false;
        $scope.PasswordsDontMatch = true;
      }
    }
  }


  $scope.Email1Error = false;
  $scope.EmailsDontMatch = false;
  $scope.CheckEmail1 = function () {
    if ($scope.Email1 == '') {
      $scope.Email1Error = true;
      $scope.EmailCheckValidationPassed = false;
    }
    else {
      if ($scope.Email != $scope.Email1) {
        $scope.EmailsDontMatch = false;
        $scope.Email1Error = true;
        $scope.EmailCheckValidationPassed = false;
      } else {
        $scope.EmailCheckValidationPassed = true;
        $scope.Email1Error = false;
        $scope.EmailsDontMatch = true;
      }
    }
  }


    $scope.placeholder;

    $scope.User = {};
    jQuery(document).ready(function ($) {
        if (Cookies.get('TLF_Auth_Token') !== undefined) {
            $http.get(TFL_Base_Url + 'auth?ApiKey=' + Cookies.get('TLF_Auth_Token'))
                .then(function (response) {
                    var data = response.data;
                    $rootScope.Loggedin = true;
                    $scope.User = data;

                    if ($scope.User.Email.toUpperCase() == "unknown@TheLottoFactory.com".toUpperCase())
                    {
                        jQuery(document).ready(function ($) {
                            $('#modal').show();
                            $('#set-initial-email').fadeIn(500);
                        });
                    }

                    if ($scope.User.ContactName == null) {
                        $scope.User.ContactName = $scope.User.FirstName + ' ' + $scope.User.LastName;
                    }
                    /*
                    rg4js('setUser', {
                      identifier: $scope.User.Id,
                      isAnonymous: false,
                      email: $scope.User.Email,
                      firstName: $scope.User.FirstName,
                      OrgId: $scope.User.OrganizationId,
                      fullName: $scope.User.FirstName + ' ' + $scope.User.LastName
                    }); */
                }, function () {
                    $rootScope.Loggedin = false;
                    Cookies.remove("TLF_Auth_Token");
                    Cookies.remove("Member_Id");
                    Cookies.remove("Email");
                });
        }
        else {
            $rootScope.Loggedin = false;
        }
    });


    $scope.InitialEmail = '';
    $scope.ConfirmInitialEmail = '';
    $scope.SetInitialEmailWorking = false;
    $scope.SetInitialEmailError = false;
    $scope.SetIntitalEmailServerError = false;

    $scope.SetInitialEmail = function () {
        $scope.SetInitialEmailError = false;

        if ($scope.InitialEmail == '') {
            $scope.SetInitialEmailError = true;
            return
        }
        if ($scope.ConfirmInitialEmail.toUpperCase() != $scope.InitialEmail.toUpperCase()) {
            $scope.SetInitialEmailError = true;
            return
        }

        $scope.SetInitialEmailWorking = true;

        SetInitialEmailSvc.post({},
            JSON.stringify({
                ApiKey: Cookies.get('TLF_Auth_Token'),
                NewEmail: $scope.InitialEmail,
                ConfirmEmail: $scope.ConfirmInitialEmail
            }), function (data) {
                $scope.User.Email = data.NewEmail
                $scope.SetInitialEmailWorking = false;

                jQuery(document).ready(function ($) {
                    $('#modal').hide();
                    $('#set-initial-email').fadeout(500);
                });

            }, function (response) {
                $scope.SetIntitalEmailServerError = true;
                $scope.SetInitialEmailWorking = false;
            })
    }

    $scope.InitialEmailServerErrorClear = function (){
        $scope.SetIntitalEmailServerError = false
    }

  $rootScope.SiteDetails = {};
  
  SiteDetailsSvc.get({}, function (data) {

    $rootScope.SiteDetails = data;
    $rootScope.SiteDetails.ShowRNGLogo = ShowRNGLogo
    $rootScope.SiteDetails.GLICertUrl = GLICertUrl
    $rootScope.SiteDetails.OperatedByCharity = OperatedByCharity

    if ($rootScope.SiteDetails.GameType == 'chase-the-ace')
    {
      $scope.ColorMode = "Light Theme";
      less.modifyVars({
        colorscheme: '"Dark"',
        '@theme-name': 'chase-the-ace'
      });
      $scope.ChangeTheme = function()
      {
        if ($scope.ColorMode == "Dark Theme")
        {
          $scope.ColorMode = "Light Theme";
          less.modifyVars({
            colorscheme: '"Dark"',
            '@theme-name': 'chase-the-ace'
          });
        }
        else
        {
          $scope.ColorMode = "Dark Theme";
          less.modifyVars({
            colorscheme: '"Light"',
            '@theme-name': 'chase-the-ace'
          });
        }
      }
    }

    $scope.homepath = 'home-' + $rootScope.SiteDetails.ThemeName + '.html?v=' + new Date().toLocaleString();

    if ($scope.SiteDetails.DrawsRemaining == 0) {
      if ($rootScope.SiteDetails.GameType != 'chase-the-ace')
      {
        if (document.location.pathname != '/closed') {
          document.location = '/closed';
        }
      }
    } 
    else
    {
      if (document.location.pathname == '/closed') {
        document.location = '/';
      }
    }



    let waitForLanguages = new Promise((resolve, reject) => {
      if ($rootScope.SiteDetails.SupportedLanguages !== undefined && $rootScope.SiteDetails.SupportedLanguages) {
        resolve($rootScope.SiteDetails.SupportedLanguages.split(","))
      }
    });

    waitForLanguages.then((supportedLanguages) => {
      var defaultLanguage = keyLanguage($rootScope.SiteDetails.DefaultLanguage);  //Store the language code, and language

      $scope.SupportedLanguages = supportedLanguages;
      for (var i = 0; i < supportedLanguages.length; i++) {
        if (supportedLanguages[i] === "English")
          $scope.SupportedLanguages[i] = 'en'; //Supported languages should be stored as two character codes to be more universal
        if (supportedLanguages[i] === "French")
          $scope.SupportedLanguages[i] = 'fr';
        if (supportedLanguages[i] === "Spanish")
          $scope.SupportedLanguages[i] = 'es';
      }

      if (Cookies.get('Language') === undefined) {
        $scope.SelectedLanguage = defaultLanguage.code;
        var lang = navigator.language.substring(0, 2);
        if (lang === 'en' && $scope.SupportedLanguages.includes('en')) {  //If the browser language is english, and the org supports english
          $translate.use('English'); //Translate the page to English (This may create a second call to OrganizationContent)
          $scope.SelectedLanguage = lang; //Set the selected language to English
        } else if (lang === 'fr' && $scope.SupportedLanguages.includes('fr')) {
          $translate.use('French');
          $scope.SelectedLanguage = lang;
        } else if (lang === 'es' && $scope.SupportedLanguages.includes('es')) {
          $translate.use('Spanish');
          $scope.SelectedLanguage = lang;
        } else
          $translate.use(defaultLanguage.language);
      } else {
        var lang = keyLanguage(Cookies.get('Language'));
        if ($scope.SupportedLanguages.includes(lang.code)) {
          $scope.SelectedLanguage = lang.code;
          $translate.use(lang.language);
        } else {
          $scope.SelectedLanguage = defaultLanguage.code;
          $translate.use(defaultLanguage.language);
        }
      }

        $scope.MobileLanguages = [];
        if ($scope.SupportedLanguages.includes("en"))
            $scope.MobileLanguages.push({ Full: "English", Short: "en" })
        if ($scope.SupportedLanguages.includes("fr"))
            $scope.MobileLanguages.push({ Full: "Fran" + '\u00e7' + "ais", Short: "fr" })
        if ($scope.SupportedLanguages.includes("es"))
            $scope.MobileLanguages.push({ Full: "Espanol", Short: "es" })
    });
  });

  //Function for keying a language. We need the language code for the html, and the full language name for $translateprovider
  function keyLanguage(language) {
    var defaultLanguage = { language: "English", code: "en" };
    if (language === "French" || language === "fr")
      defaultLanguage = { language: "French", code: "fr" };
    if (language === "Spanish" || language === "es")
      defaultLanguage = { language: "Spanish", code: "es" };
    return defaultLanguage;
  }

  $scope.changeLanguage = function (language) {
    $scope.SelectedLanguage = language;
    $translate.use(keyLanguage(language).language);

    var date = new Date();
    date.setTime(date.getTime() + (1209600000)); //Two weeks
    Cookies.set('Language', language, { expires: date });

    location.reload();
  }

  SiteDetail_AddressSvc.get({}, function (data) {
      $rootScope.SiteDetail_Address = data;
  });

  $scope.CheckIfEmail = function () {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test($scope.emailField);
  }


  $scope.ResetUser = function ()
  {
      //v1/member/remove?ApiKey=dfgdfg
      jQuery(document).ready(function ($) {
          if (Cookies.get('TLF_Auth_Token') !== undefined) {
              $http.get(TFL_Base_Url + 'member/remove?ApiKey=' + Cookies.get('TLF_Auth_Token'))
                .then(function () {
                    $scope.Logout();
                }, function () {
                    $scope.Logout();
                });
          }
          else {
              $scope.Logout();
          }
      });

  }

  $scope.Logout = function () {

      Cookies.remove("TLF_Auth_Token");
      Cookies.remove("Member_Id");
      Cookies.remove("Email");
      Cookies.remove('TLF_HasLoggedIn'); // remove cookie so they don't get a reminder the next time they visit if they're logged out

      $timeout(function () {
          $rootScope.Loggedin = false;
          delete $scope['User'];
          $location.url($location.path('/').replace());
          $location.path('/').replace();
          location.reload()
      });


      jQuery(document).ready(function ($) {
          $('#modal').hide();
          $('#password-reset-2').fadeOut(0);
      });

  }

  $scope.EmailDoesntExistError = false;

  $scope.Forgot_Email_Password = function () {
      EmailForgotSvc.get({ Email: $scope.ForgotEmail }, function (data) {
          $scope.EmailDoesntExistError = false;
          jQuery(document).ready(function ($) {
              //Close Modal
              $('#modal .content').hide();
              //Email sent modal
              $('#modal #password-reset').fadeIn(400);
          });
      }, function (error) {
          $scope.EmailDoesntExistError = true;
      });
  }

    $scope.PasswordsDontMatch = false;

  $scope.ResetPassword = function () {

      if ($scope.Password != '') {
          if ($scope.Password == $scope.Password1) {
              $scope.PasswordsDontMatch = false;
              jQuery(document).ready(function ($) {
                  ResetPasswordSvc.get({ Email: Cookies.get('Email'), MemberId: Cookies.get('Member_Id'), Password: $scope.Password }, function (data) {
                      //Close Modal
                      $('#modal').hide();
                      //Email sent modal
                      $('#modal #password-reset-form').fadeOut(700);
                      Cookies.remove('Member_Id');
                      Cookies.remove('Email');
                      setTimeout(function () {
                          $('#modal').show();
                          $('#modal #password-reset-success').fadeIn(700);
                      }, 500);
                  }, function () {
                      //Add line on modal that says there was an error and to try again. If error persists contact $rootScope.OperatingCompanySupportEmail
                      $scope.passwordResetError = true
                  });
              });
          }
          else
          {
              $scope.PasswordsDontMatch = true;
          }
      }
  }

  $scope.scorePassword = function (pass) {

      var score = 0;
      if (!pass)
          return score;

      // award every unique letter until 5 repetitions
      var letters = new Object();
      for (var i=0; i<pass.length; i++) {
          letters[pass[i]] = (letters[pass[i]] || 0) + 1;
          score += 5.0 / letters[pass[i]];
      }

      // bonus points for mixing it up
      var variations = {
          digits: /\d/.test(pass),
          lower: /[a-z]/.test(pass),
          upper: /[A-Z]/.test(pass),
          nonWords: /\W/.test(pass),
      }

      var variationCount = 0;
      for (var check in variations) {
          variationCount += (variations[check] == true) ? 1 : 0;
      }
      score += (variationCount - 1) * 10;

      return parseInt(score);

  }

  $scope.Password_Blur = function (lang) {
    var score = $scope.scorePassword($scope.Password);
    if (lang === 'en') {
      if (score > 80) {
        $scope.PasswordStrength = "str_6";
        $scope.PasswordStrengthText = "Excellent";
        return;
      }

      if (score > 60) {
        $scope.PasswordStrength = "str_5";
        $scope.PasswordStrengthText = "Good";
        return;
      }
      if (score >= 30) {
        $scope.PasswordStrength = "str_3";
        $scope.PasswordStrengthText = "Not Bad";
        return;
      }
      if (score < 30) {
        $scope.PasswordStrength = "str_1";
        $scope.PasswordStrengthText = "Weak";
        return;
      }
    } else if (lang === 'fr') {
      if (score > 80) {
        $scope.PasswordStrength = "str_6";
        $scope.PasswordStrengthText = "Excellent";
        return;
      }

      if (score > 60) {
        $scope.PasswordStrength = "str_5";
        $scope.PasswordStrengthText = "Bien";
        return;
      }
      if (score >= 30) {
        $scope.PasswordStrength = "str_3";
        $scope.PasswordStrengthText = "Pas Mal";
        return;
      }
      if (score < 30) {
        $scope.PasswordStrength = "str_1";
        $scope.PasswordStrengthText = "Faible";
        return;
      }
    } else if (lang === 'es') {
      if (score > 80) {
        $scope.PasswordStrength = "str_6";
        $scope.PasswordStrengthText = "Excelente";
        return;
      }

      if (score > 60) {
        $scope.PasswordStrength = "str_5";
        $scope.PasswordStrengthText = "Bueno";
        return;
      }
      if (score >= 30) {
        $scope.PasswordStrength = "str_3";
        $scope.PasswordStrengthText = "No est" + "\u00E1" + " mal";
        return;
      }
      if (score < 30) {
        $scope.PasswordStrength = "str_1";
        $scope.PasswordStrengthText = "D" + "\u00E9" +"bil";
        return;
      }
    } else {
      if (score > 80) {
        $scope.PasswordStrength = "str_6";
        $scope.PasswordStrengthText = "Excellent";
        return;
      }

      if (score > 60) {
        $scope.PasswordStrength = "str_5";
        $scope.PasswordStrengthText = "Good";
        return;
      }
      if (score >= 30) {
        $scope.PasswordStrength = "str_3";
        $scope.PasswordStrengthText = "Not Bad";
        return;
      }
      if (score < 30) {
        $scope.PasswordStrength = "str_1";
        $scope.PasswordStrengthText = "Weak";
        return;
      }
    }
  }

  $scope.EmailCheckValidationReset = function()
  {
      $scope.EmailCheckValidationPassed = true;

      $scope.FirstNameError = false;
      $scope.LastNameError = false;
      $scope.EmailError = false;
      $scope.PasswordError = false;
      $scope.Password1Error = false;

      $scope.CommitSignup = false;

      $scope.FirstName = '';
      $scope.LastName = '';
      $scope.Email = '';
      $scope.Password = '';
      $scope.Password1 = '';
   
      $timeout(function () {
        $scope.ShowPostalCode = false;
      });
  }

  $scope.CommitSignup = false;

	//Email Signup Validation
  $scope.SignUp_Email = function () {

    $scope.CheckFirstName();
    $scope.CheckLastName();
    $scope.CheckEmail();
    $scope.CheckPassword();
    $scope.CheckPassword1();

    if ($scope.EmailCheckValidationPassed) {
      if ($scope.ShowPostalCode) {
        $scope.CommitSignup = true;
        $scope.CheckPostal();
      }
      else
      {
        $scope.DoSignup();
      }
    }
    else
    {
      $scope.ErrorShake = true;
      $timeout(function () {
        $scope.ErrorShake = false;
      }, 1000);
    }
  }

  $scope.FinalizationProcessing = false

    $scope.Finalize_Email = function () {
        $scope.FinalizationProcessing = true
        $scope.EmailCheckValidationPassed = true;
        $scope.CheckPassword();
        $scope.CheckPassword1();

        if ($scope.EmailCheckValidationPassed) {
            $scope.doFinalize();
        }
        else {
            $scope.ErrorShake = true;
            $timeout(function () {
                $scope.ErrorShake = false;
                $scope.FinalizationProcessing = false
            }, 1000);
        }
    }

    $scope.doFinalize = function () {
        EmailFinalizationSvc.post({ Password: $scope.Password, ConfirmPassword: $scope.Password1, MemberId: $rootScope.MemberId, reCaptcha: $scope.gRecaptchaResponse }, function (data) {
					jQuery(document).ready(function ($) {

						var date = new Date();
						var minutes = 60000;
						date.setTime(date.getTime());
						Cookies.set('Finalize_Member', '', { expires: date });


                $('#modal').fadeOut(500, function () {
                    $('#modal .content').hide();
                });

                $scope.FinalizationProcessing = false

                $window.location.href = '/auth?ApiKey=' + data.APIKey;
            });
        }, function (response) {
            //404 or bad
            if (response.status === 400) {
                $scope.EmailError = true;
                $scope.FinalizationProcessing = false
                delete ($scope.gRecaptchaResponse);
            }
        });
    }

	//Email Signup
  $scope.DoSignup = function ()
  {
		EmailRegistrationgSvc.post({ Email: $scope.Email, Password: $scope.Password, ConfirmPassword: $scope.Password1, FullName: $scope.FirstName + " " + $scope.LastName, reCaptcha: $scope.gRecaptchaResponse }, function (data) {
      jQuery(document).ready(function ($) {
        $('#modal').fadeOut(500, function () {
          $('#modal .content').hide();
        });

        $window.location.href = '/auth?ApiKey=' + data.APIKey;

      });
    }, function (response) {
      if (response.status === 400) {
        $scope.EmailError = true;
        delete ($scope.gRecaptchaResponse);
      } else if (response.status === 403) { //player-exclusion
        document.location = '/excluded';
      }
    });
  }

	//Email Login
  $scope.Login_Email = function () {

      //Validation Stuff
      $scope.CheckEmail();
      $scope.CheckPassword();

      EmailLoginSvc.post({ Email: $scope.Email, Password: $scope.Password}, function (data) {
          jQuery(document).ready(function ($) {
              $('#modal').fadeOut(500, function () {
                  $('#modal .content').hide();
              });
              $rootScope.Loggedin = true;
              $scope.User = data;
              $window.location.href = '/auth?ApiKey=' + data.APIKey;
          });
      }, function (response) {
          //404 or bad
				if (response.status === 400) {

					if (response.data.Status == 'invalid username/password') {
						$scope.EmailError = true;
						$scope.PasswordError = true;
						$scope.ErrorShake = true;
						$timeout(function () {
							$scope.ErrorShake = false;
						}, 1000);
					}
					else
					{
						jQuery(document).ready(function ($) {
							$('#modal').fadeIn(500, function () {
								$('#login-form').hide();
								$('#locked-out').show();
							});
						});
					}

        }
      });
  }

  $scope.buildFAQTexts = function (Page) {
    if (Page.charAt(0) == 'F') {
      $scope.FAQTexts = [];
      $translate(Page).then(function (result) {
        $scope.FAQTexts = JSON.parse(result);
      });
    } else {
      $scope.FAQTexts = JSON.parse(Page);
    }
  }

  $scope.CloseUnsubscribe = function () {
    jQuery(document).ready(function ($) {
      $('#modal').hide();
      $('#unsubscribe').fadeOut(500);
    });
  }

  $scope.CloseUnsubscribeError = function () {
    jQuery(document).ready(function ($) {
      $('#modal').hide();
      $('#unsubscribe-error').fadeOut(500);
    });
  }

  $scope.CloseNoFacebookModal = function () {
    jQuery(document).ready(function ($) {
      $('#modal').hide();
      $('#facebook-profile-notfound').fadeOut(500);
    });
  }

  $scope.CloseNoGoogleModal = function () {
    jQuery(document).ready(function ($) {
      $('#modal').hide();
      $('#google-profile-notfound').fadeOut(500);
    });
  }

/*
* This function is for setting the 'OR' text inside the login/signup modals.
* When attempting to add the text using just angular, the 'OR' gets spit outside the circle.
* Instead by appending the class we are able to ensure that the 'OR' is always within the circle.
*/
  $scope.buildModalOr = function (Page) {
    $scope.ModalOr = "";
    if (Page == "ModalOr") {
      $translate(Page).then(function (result) {
        $scope.ModalOr = result;
        var style = document.createElement("style");
        style.append(".orCla:before{content :'" + $scope.ModalOr + "';}");
        document.getElementById('modal').append(style);
      });
    } else {
      $scope.ModalOr = Page;
      var style = document.createElement("style");
      style.append(".orCla:before{content :'" + $scope.ModalOr + "';}");
      document.getElementById('modal').append(style);
    }
  }
  
  // lets us check how many tickets a user has outside of the Tickets page

  $scope.TicketCount = function () {
    jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
        MyTicketsMonthYearSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), Year: $scope.CurrentYear, Month: $scope.CurrentMonth }, function (data) {
          $rootScope.TicketCount = data;
          $scope.ShowButton = true
        });
        $http.get(TFL_Base_Url + 'member/orders?ApiKey=' + Cookies.get('TLF_Auth_Token')).then(function (data) {
          $rootScope.ShowOrderHistory = data.data;
        });
      }
      else {
        $scope.ShowButton = true
      }
    });
  }

  $scope.TicketCount();
};

export default {
  name: 'MainCTRL',
  fn: MainController
}
